var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%", display: "block" } },
    [
      _c(
        "el-row",
        { staticClass: "scroll-style" },
        [
          _c(
            "el-form",
            {
              ref: "scrollForm",
              attrs: {
                model: _vm.scrollForm,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.scroll") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.changeScrollCfg },
                      model: {
                        value: _vm.scrollForm.open,
                        callback: function ($$v) {
                          _vm.$set(_vm.scrollForm, "open", $$v)
                        },
                        expression: "scrollForm.open",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.open")))]
                  ),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { effect: "dark", placement: "bottom" },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("chart.table_scroll_tip")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c("i", {
                        staticClass: "el-icon-info",
                        staticStyle: {
                          cursor: "pointer",
                          color: "gray",
                          "font-size": "12px",
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.scrollForm.open,
                      expression: "scrollForm.open",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.row") },
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 1,
                          max: 1000,
                          precision: 0,
                          size: "mini",
                        },
                        on: { change: _vm.changeScrollCfg },
                        model: {
                          value: _vm.scrollForm.row,
                          callback: function ($$v) {
                            _vm.$set(_vm.scrollForm, "row", $$v)
                          },
                          expression: "scrollForm.row",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.interval") + "(ms)" },
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 500,
                          step: 1000,
                          precision: 0,
                          size: "mini",
                        },
                        on: { change: _vm.changeScrollCfg },
                        model: {
                          value: _vm.scrollForm.interval,
                          callback: function ($$v) {
                            _vm.$set(_vm.scrollForm, "interval", $$v)
                          },
                          expression: "scrollForm.interval",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }